import React from "react";
import { BulletList } from "react-content-loader";

export default function ListLoader() {
  return <BulletList style={{ height: "12em", margin: "0 10px" }} />;
}
